import baseService from './baseService'

const emailService = {
  async sendEmail({ email, naam, ontvangerNaam, opgave, schoolType, thema, adres, plaats }: { email: string, naam: string, ontvangerNaam: string, opgave: string, schoolType: string[], thema: string[], adres: string, plaats: string}) {
    const emailData : {
      RapportNaam: string,
      Adres: string,
      Plaats: string,
      OntvangerNaam: string,
      Opgave: string[],
      EmailToggle: boolean,
      Email: string,
      GUID: string,
      "Rapportage bevat Thema's": {
           ThemaNaam: string
        }[],
        'Rapportage bevat Schooltypen': {
          SchooltypeAfkorting: string
        }[]
    } = {
      RapportNaam: naam,
      Adres: adres,
      Plaats: plaats,
      OntvangerNaam: ontvangerNaam,
      Opgave: [opgave],
      EmailToggle: true,
      Email: email,
      GUID: crypto.randomUUID(),
        "Rapportage bevat Thema's": [
          {
            ThemaNaam: 'Basis',
          }
        ],
        'Rapportage bevat Schooltypen': [],
    }

    schoolType.forEach(element => {
      emailData['Rapportage bevat Schooltypen'].push({
        SchooltypeAfkorting: element,
      })
    });

    thema.forEach(element => {
      emailData["Rapportage bevat Thema's"].push({
        ThemaNaam: element,
      })
    });

    return await baseService.processRequest<null, string>(`clients/receiver/projects/${import.meta.env.VITE_APP_DATASTORMS_PROJECT}/postRapportageInstantie`,
      [emailData])
  },
}

export default emailService
